let stub = {
  geocode: [],
  geocodeFromPlace: [],
  getPlacePredictions: [],
};

class GoogleMapsServiceStub {
  setStub(value) {
    stub = value;
  }

  getStub() {
    return stub;
  }

  geocode() {
    return new Promise((resolve) => {
      resolve(stub.geocode.shift());
    });
  }
  geocodeFromPlace() {
    return new Promise((resolve) => {
      resolve(stub.geocodeFromPlace.shift());
    });
  }

  getPlacePredictions() {
    return new Promise((resolve) => {
      resolve(stub.getPlacePredictions.shift());
    });
  }

  cleanAddress(address) {
    return address && address.replace(/, Brasil$/i, '').replace(/(,\s)?\d{5}-\d{3}/, '');
  }
}

export default GoogleMapsServiceStub;
